import { useEffect } from "react";
import { api } from "@/lib/api";
import { useCachedState } from "@/lib/swr";

// Single source of truth for pricing/tier badges. Fetches the add-on catalog once
// (cached app-wide) so "Premium" labels are derived from the billing catalog, never
// hardcoded in the UI. Returns { catalog, byKey, loaded }.
export function useAddonCatalog() {
  const [catalog, setCatalog] = useCachedState("addon-catalog", null);
  useEffect(() => {
    if (catalog) return;
    api.get("/addons/catalog").then((r) => setCatalog(r.data.catalog || [])).catch(() => {});
  }, [catalog, setCatalog]);
  const byKey = {};
  for (const a of catalog || []) byKey[a.key] = a;
  return { catalog: catalog || [], byKey, loaded: !!catalog };
}
